import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Blog.css";

const Blog = () => {
  const highlightRef = useRef(null);
  const highlightRef2 = useRef(null);
  const tipRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.25 }
    );

    if (highlightRef.current) observer.observe(highlightRef.current);
    if (highlightRef2.current) observer.observe(highlightRef2.current);
    tipRefs.current.forEach((tip) => tip && observer.observe(tip));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* HERO */}
      <header className="blog-hero">
        <div className="blog-hero-overlay">
          <h1 className="blog-hero-title">
            How to Continue Growing Your Business at This Time:
            <span> COVID-19 Second Wave</span>
          </h1>
        </div>
      </header>

      {/* BLOG CONTENT */}
      <section className="blog-content-section">
        <div className="blog-content-container">
          <p>
            With the entire country acting quickly to reduce the spread of
            COVID-19, the past few weeks have been immensely challenging for all
            of India. As we’re passing from the second wave of COVID-19 with all
            restrictions, businesses are experiencing unprecedented impact and a
            huge change for the foreseeable future. While there is undoubtedly
            uncertainty, one thing is more clear than ever: the crucial role
            that digital communication plays in everyday life.
          </p>
        </div>
      </section>

      {/* HIGHLIGHT CARD */}
      <section className="highlight-section">
        <div className="highlight-card animate" ref={highlightRef}>
          <p>
            Social distancing and self-isolation mean that social media has
            become the primary way that people are now interacting. While
            Facebook, Instagram, Twitter, and Linkedin were obviously popular
            before, their use during the pandemic has escalated. In addition to
            this, Google and other websites are some of the only ways people can
            find out information about products, services, and any other news
            they want to know.
          </p>
        </div>
      </section>

      <section className="blog-content-section">
        <div className="blog-content-container">
          <p>
            What this means for businesses is that an online presence is crucial
            during this period. More people than ever are active online and they
            continue to need information about the things that are important to
            them. If growth for your business is still on top of your mind during this
            time, digital communications should be a priority over the next few
            weeks. Deploying available tools can make an enormous difference to
            how people interact with you in the current climate and allow you
            to effectively engage with your customers.
          </p>
        </div>
      </section>

      {/* TIPS SECTION */}
      <section className="blog-tips-section">
        <div className="blog-tips-container">
          <h2 className="blog-tips-title">
            Our few tips for continuing to sustainably grow your business during
            this period:
          </h2>

          <div
            className="blog-tip animate-left"
            ref={(el) => (tipRefs.current[0] = el)}
          >
            <h3>1. Build your online presence</h3>
            <p>
              Make it easy for people to find you when they’re looking for you.
              The last thing you need during this time is for people to have
              trouble locating your website or social media page, so put in the
              effort to create accounts and get your site indexed by Google.
              Working to get your website ranked on Google’s search results page
              is called Search Engine Optimisation (SEO) and will allow you to
              get discovered when people search for your keywords online.
            </p>
          </div>

          <div
            className="blog-tip animate-left delay-1"
            ref={(el) => (tipRefs.current[1] = el)}
          >
            <h3>2. Sustain your virtual community</h3>
            <p>
              It’s never been more important to pay attention to the
              relationship you have with your community, so don’t wait to start
              connecting. To say there’s been a shift in how the consumer
              behaves and interacts would be a huge understatement. As
              mentioned, your customers are set to be more active than ever on
              social media, so if you’re looking to keep things going, it’s time
              to start engaging. Conduct market research by asking questions and
              share stimulating content for your target audience.
            </p>
          </div>

          <div
            className="blog-tip animate-left delay-2"
            ref={(el) => (tipRefs.current[2] = el)}
          >
            <h3>3. Communicate, communicate, and communicate!</h3>
            <p>
              It’s essential to stay in touch with your customers and keep them
              updated on your services through this time. This could be as
              simple as reaching out to them via email, notifying of any
              adjustments to your service delivery. If appropriate, you could
              also create offers for online shopping, a delivery service, or
              another feature that helps them to solve their current problems.
              Staying in touch with your customers will welcome their support in
              various forms and won’t let your business hide behind the trees.
              Visibility of your products/services is important despite a
              short-term closure of operating hours. In order to accelerate your
              business performance once the economy recovers, sustainable
              investment into web services now will be a smart move.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL HIGHLIGHT CARD */}
      <section className="highlight-section highlight-final">
        <div className="highlight-card animate" ref={highlightRef2}>
          <p className="highlight-quote">
            “It takes a pandemic to show business resilience!”
          </p>

          <p>
            Nourishing a market presence with a bit of optimism is very
            fundamental in current times. So stay on the move, make efficient
            business decisions, and think long-term.
          </p>
        </div>
      </section>

      {/* FINAL CTA CONTENT */}
      <section className="blog-content-section blog-cta-section">
        <div className="blog-content-container1">
          <p>
            <Link to="/contact" className="blog-contact-link">
              <strong>Contact us</strong>
            </Link>{" "}
            for advice on growing your business through COVID-19 restrictions.
          </p>
          <br></br>
          <p>
            OnenessWeb is continuing to operate as usual during this period and
            is endeavoring to assist businesses in maintaining their customer
            bases and building their digital presence in the coming months. If
            you’d like any advice on digital marketing and website development,
            please don’t hesitate to get in touch with us.
          </p>
        </div>
      </section>

    </>
  );
};

export default Blog;
